// Autogenerated file
export const trackerLogSourceTypesEnum = {
    Default: "Default",
    Mobile: "Mobile",
    Incorrect: "Incorrect",
};
export const trackerLogSourceTypes = [
    { label: "Данные с трекера", value: "Default", intValue: 0 },
    { label: "Данные с телефона", value: "Mobile", intValue: 1 },
    { label: "Поврежденные данные", value: "Incorrect", intValue: 2 },
];
